import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  console.log('API request interceptor:', {
    url: config.url,
    method: config.method,
    hasToken: !!token,
    headers: config.headers
  })

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
    console.log('Token added to request:', {
      url: config.url,
      method: config.method,
      authorization: config.headers.Authorization
    })
  }
  return config
}, (error) => {
  console.error('API request interceptor error:', error)
  return Promise.reject(error)
})

// Handle token expiration
api.interceptors.response.use(
  (response) => {
    console.log('API response interceptor:', {
      url: response.config.url,
      method: response.config.method,
      status: response.status,
      headers: response.headers
    })
    return response
  },
  (error) => {
    console.error('API response interceptor error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      headers: error.response?.headers
    })

    // Don't redirect if we're already on the login page with profile completion
    const isLoginPage = window.location.pathname === '/login';
    const isProfileCompletion = window.location.search.includes('showSocialMedia=true');

    if (error.response?.status === 401 && !isLoginPage) {
      console.log('Token expired or invalid, clearing token and redirecting to login')
      localStorage.removeItem('token')
      delete api.defaults.headers.common['Authorization']
      window.location.href = '/login'
    } else if (error.response?.status === 403 && 
               error.response?.data?.profileStatus === 'draft' && 
               error.config?.url?.includes('/api/auth/me') &&
               !isProfileCompletion) {
      // Only redirect to profile completion if we're not already there
      console.log('Profile incomplete, redirecting to profile completion')
      window.location.href = '/login?showSocialMedia=true'
    }
    return Promise.reject(error)
  }
) 